import React from 'react';
import { RootWrapper, ScreenReaderOnly } from '../Shared/SharedStyles';

const PlaceholderSVGLayer = () => (
    <svg width="100%" height="600" viewBox="0 0 100% 600" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g fillOpacity="0.10" fill="#8E90A2">
            <rect x="0%" y="10px" width="60%" height="40px" rx="2" />
            <rect x="0%" y="102px" width="20%" height="18px" rx="2" />
            <rect x="0%" y="132px" width="30%" height="18px" rx="2" />
            <rect x="0%" y="164px" width="25%" height="18px" rx="2" />
            <rect x="0%" y="194px" width="32%" height="18px" rx="2" />
            <rect x="0%" y="226px" width="10%" height="18px" rx="2" />
            <rect x="0%" y="258px" width="15%" height="18px" rx="2" />
            <rect x="0%" y="290px" width="25%" height="18px" rx="2" />
            <rect x="0%" y="322px" width="12%" height="18px" rx="2" />
            <rect x="0%" y="354px" width="45%" height="18px" rx="2" />
            <rect x="0%" y="386px" width="50%" height="40px" rx="2" />
            <rect x="0%" y="450px" width="8%" height="40px" rx="2" />
            <rect x="11%" y="450px" width="85%" height="40px" rx="2" />
            <rect x="0%" y="546px" width="40%" height="50px" rx="2" />
            <rect x="60%" y="546px" width="100%" height="50px" rx="2" />
        </g>
    </svg>
);

const ExtendCoverageModalLoadingIndicator = ({ shouldAnnounce = true, ...rest }) => (
    <RootWrapper {...rest}>
        {shouldAnnounce && <ScreenReaderOnly>Loading / Chargement</ScreenReaderOnly>}
        <PlaceholderSVGLayer />
    </RootWrapper>
);

export default ExtendCoverageModalLoadingIndicator;
